import { rawMaterialsURL } from "@/config/api-config";

const rmSourceLayer = {
  url: rawMaterialsURL,
  id: "rmSourceLayer",
  title: "Raw Material Source",
  outFields: ["*"],
  visible: false,
  featureReduction: {
    type: "cluster",
    clusterRadius: "100px",
    clusterMinSize: "24px",
    clusterMaxSize: "60px",

    popupTemplate: {
      title: function (event) {
        const feature = event.graphic?.attributes;
        const avg = feature?.cluster_avg_suppliedTonnage || 0;
        const count = feature?.cluster_count || 0;
        const total = avg * count;
        const community =
          feature?.cluster_type_community || "This";
        // const formattedTotal =
        //   total >= 1000000
        //     ? `${(total / 1000000).toFixed(1)}m`
        //     : total >= 1000
        //     ? `${(total / 1000).toFixed(1)}k`
        //     : total.toFixed(2);

            const formattedTotal = total?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });

        return `${community} Community - ${formattedTotal} Tons Purchased`;
      },
      content: [
        {
          type: "custom",
          creator: function (event) {
            const feature = event.graphic?.attributes;
            const avg = feature?.cluster_avg_suppliedTonnage || 0;
            const count = feature?.cluster_count || 0;
            const community = feature?.cluster_type_community || "Community";
          
            const container = document.createElement("div");
            container.style.margin = "0 0 15px 0";
            container.innerHTML =
              "<div class='esri-popup__content-element' style='font-weight:bold;'>Loading community data...</div>";
        
            const query = event.graphic.layer.createQuery();
            
            let whereClause = `Community = '${community}'`;
            
            const layerDefinition = event.graphic.layer.definitionExpression;
            if (layerDefinition) {
              whereClause += ` AND (${layerDefinition})`;
            }
            
            query.where = whereClause;
            query.outFields = ["pricePerTon", "suppliedTonnage"];
            query.returnGeometry = false;
          
            event.graphic.layer
              .queryFeatures(query)
              .then((result) => {
                let totalPrice = 0;
                let validPriceCount = 0;
                result.features.forEach((f) => {
                  const priceStr = f.attributes.pricePerTon || "";
                  const price = parseFloat(priceStr.replace(/[^0-9.]/g, ""));
                  if (!isNaN(price)) {
                    totalPrice += price;
                    validPriceCount++;
                  }
                });
          
                // Calculate average price
                const avgPrice = validPriceCount > 0 ? totalPrice / validPriceCount : 0;
                const formattedAvgPrice = avgPrice?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                });
          
                container.innerHTML = `
                  <div class='esri-popup__content-element' style='background-color:#f8f8f8; padding:8px; border-radius:4px; margin-bottom:10px; border-left:4px solid #ff9900;'>
                    <div style='font-weight:bold;'>Total number of transactions:</div>
                    <div style='font-size:1.2em; font-weight:bold;'>${count}</div>
                    <div style='font-weight:bold;'>Average P1 purchased:</div>
                    <div style='font-size:1.2em; font-weight:bold;'>${avg.toFixed(2)} tons</div>
                    <div style='font-weight:bold;'>Average P1 price:</div>
                    <div style='font-size:1.2em; font-weight:bold;'>₦${formattedAvgPrice}</div>
                  </div>
                `;
              })
              .catch((error) => {
                console.error("Query failed:", error);
                container.innerHTML =
                  "<div class='esri-popup__content-element' style='color:red;'>Error calculating community data.</div>";
              });
          
            return container;
          },
        },
      ],
    },

    labelingInfo: [
      {
        labelExpressionInfo: {
          expression:
            "Text($feature.cluster_avg_suppliedTonnage * $feature.cluster_count, '#,###.##') + ' tonnage'",
        },
        symbol: {
          type: "text",
          color: "white",
          haloColor: "black",
          haloSize: 1,
          font: { size: 12, weight: "bold" },
        },
      },
    ],

    visualVariables: [
      {
        type: "size",
        field: "cluster_count",
        valueExpression:
          "$feature.cluster_avg_suppliedTonnage * $feature.cluster_count",
        valueExpressionTitle: "Total Tonnage",
        minDataValue: 1,
        maxDataValue: 1000,
        minSize: 24,
        maxSize: 60,
        legendOptions: {
          title: "Total Tonnage",
        },
      },
    ],
  },

  renderer: {
    type: "unique-value",
    field: "community",
    defaultSymbol: {
      type: "simple-marker",
      color: "#452B1F",
      size: 24,
      outline: { color: "rgba(69, 43, 31, 1%)", width: 1 },
    },
    uniqueValueInfos: [],
    visualVariables: [
      {
        type: "opacity",
        field: "suppliedTonnage",
        stops: [
          { value: 0, opacity: 1 },
          { value: 100, opacity: 1 },
        ],
        legendOptions: {
          showLegend: false,
        },
      },
    ],
  },

  popupTemplate: {
    title: "P1 Purchase",
    content: [
      {
        type: "fields",
        fieldInfos: [
          { fieldName: "date", label: "Date", type: "date", format: { dateFormat: "short-date" } },
          { fieldName: "supplierName", label: "Supplier Name" },
          { fieldName: "phoneNumber", label: "Phone Number" },
          { fieldName: "community", label: "Community" },
          { fieldName: "lga", label: "LGA" },
          { fieldName: "suppliedTonnage", label: "P1 Supplied (tonnage)" },
          { fieldName: "pricePerTon", label: "Price per Ton" },
        ],
      },
    ],
  },
};

export default rmSourceLayer;
